import { IconProps } from '../types';

const IcMediaLibrary = (props: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    {...props}
  >
    <path
      d='M7.50004 10.8332H15.8334L12.9584 7.08317L11.0417 9.58317L9.75004 7.9165L7.50004 10.8332ZM2.50004 17.4998C2.04171 17.4998 1.64935 17.3366 1.32296 17.0103C0.996568 16.6839 0.833374 16.2915 0.833374 15.8332V4.99984H2.50004V15.8332H16.6667V17.4998H2.50004ZM5.83337 14.1665C5.37504 14.1665 4.98268 14.0033 4.65629 13.6769C4.3299 13.3505 4.16671 12.9582 4.16671 12.4998V3.33317C4.16671 2.87484 4.3299 2.48248 4.65629 2.15609C4.98268 1.8297 5.37504 1.6665 5.83337 1.6665H10L11.6667 3.33317H17.5C17.9584 3.33317 18.3507 3.49637 18.6771 3.82275C19.0035 4.14914 19.1667 4.5415 19.1667 4.99984V12.4998C19.1667 12.9582 19.0035 13.3505 18.6771 13.6769C18.3507 14.0033 17.9584 14.1665 17.5 14.1665H5.83337ZM5.83337 12.4998H17.5V4.99984H10.9792L9.31254 3.33317H5.83337V12.4998ZM5.83337 12.4998V3.33317V4.99984V12.4998Z'
      fill={props?.fill ?? '#232F3E'}
    />
  </svg>
);

export default IcMediaLibrary;
